export type ContextAwareCookieOptions = {
  path: '/';
  sameSite: 'lax' | 'none';
  secure: boolean;
  maxAge?: number;
  partitioned?: boolean;
};

export const EMBED_CONTEXT_COOKIE_NAME = 'embed_context';
export const EMBED_CONTEXT_COOKIE_VALUE = '1';

type BuildContextAwareCookieOptionsProps = {
  isEmbedded: boolean;
  maxAge?: number;
};

export function isEmbeddedBrowserContext(): boolean {
  try {
    return typeof window !== 'undefined' && window.self !== window.top;
  } catch {
    // Cross-origin frame blocked access to window.top.
    return true;
  }
}

export function getContextAwareCookieOptions({
  isEmbedded,
  maxAge,
}: BuildContextAwareCookieOptionsProps): ContextAwareCookieOptions {
  if (isEmbedded) {
    return {
      path: '/',
      sameSite: 'none',
      partitioned: true,
      secure: true,
      maxAge,
    };
  }

  return {
    path: '/',
    sameSite: 'lax',
    secure: true,
    maxAge,
  };
}
